import React from 'react';
import parkProLogo from '../../../../assets/ParkPro White_Long.svg';

const QuestionnaireModeChoice = ({
  onChooseFastTrack,
  onChooseFull,
  isAgentForm,
  agentInfo,
  agencyInfo,
  publicInfoError,
}) => {
  const hasAgentBranding = isAgentForm && (agentInfo || agencyInfo);

  const agentName = agentInfo
    ? [agentInfo.firstname, agentInfo.lastname].filter(Boolean).join(' ')
    : null;

  const agencyName = agencyInfo?.name || null;

  const planningWithLine = (() => {
    if (!hasAgentBranding) return null;
    if (agencyName && agentName) return `${agencyName} • ${agentName}`;
    if (agencyName) return agencyName;
    if (agentName) return agentName;
    return null;
  })();

  return (
    <div className="flex flex-col px-3 pt-4 pb-0 min-h-screen sm:px-4 sm:pt-5 sm:pb-0 lg:px-6 questionnaire-v2-shell">
      <div className="flex flex-col flex-1 justify-center mx-auto w-full max-w-3xl">
        <div className="-translate-y-8">
        {hasAgentBranding && (
          <div className="q2-mode-header mb-2 rounded-xl px-3 py-2.5">
            <div className="flex flex-wrap gap-2 items-center sm:flex-nowrap">
              <span className="text-sm font-medium text-white/80">Planning with</span>
              <div className="flex gap-2 items-center min-w-0">
                {planningWithLine && (
                  <span className="text-sm font-semibold text-white truncate">{planningWithLine}</span>
                )}
              </div>
            </div>
          </div>
        )}

        {publicInfoError && (
          <div className="p-3 mb-3 rounded-xl q2-panel-error">
            <p className="text-sm" role="alert">
              {publicInfoError}
            </p>
          </div>
        )}

        <main
          className="relative px-4 pt-5 pb-0 rounded-2xl q2-mode-choice-main q2-mode-main sm:px-6 sm:pt-6 sm:pb-0 lg:px-8 lg:pt-7 lg:pb-0"
          id="main-content"
        >
          <div className="absolute top-4 right-4 sm:top-5 sm:right-5 lg:top-6 lg:right-6">
            <div className="flex items-center px-2 py-1 rounded-lg q2-mode-badge">
              <span className="text-xs font-medium">Secure &amp; private</span>
            </div>
          </div>

          <div className="flex flex-col items-center mb-6 text-center">
            <h1 className="mb-1.5 text-2xl font-bold leading-tight q2-mode-title sm:text-3xl">
              {hasAgentBranding ? "Let's plan your trip" : "Start your trip plan"}
            </h1>

            <p className="max-w-xl text-sm leading-relaxed text-center q2-mode-subtitle sm:text-base" style={{ lineHeight: 1.6 }}>
              {hasAgentBranding ? (
                <>
                  Answer a few questions and we'll build a personalized itinerary around your group.{" "}
                  <span className="text-white/80">
                    Your travel agent will review your answers before finalizing your plan.
                  </span>
                </>
              ) : (
                <>
                  Answer a few questions and we'll build a personalized itinerary around your group.
                </>
              )}
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 sm:gap-5">
            <button
              type="button"
              onClick={onChooseFull}
              className={[
                "relative flex flex-col p-5 text-left rounded-xl transition-all duration-200",
                "q2-mode-option group focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900",
                "sm:p-5",
              ].join(" ")}
              aria-label="Choose the full questionnaire for the most personalized itinerary"
            >
              <div className="absolute top-3 right-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-500/20 text-blue-300 border border-blue-600">
                  Recommended
                </span>
              </div>

              <div className="flex justify-center items-center mb-3 w-11 h-11 text-blue-300 bg-blue-600 rounded-lg shrink-0">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                  />
                </svg>
              </div>

              <h2 className="text-lg font-semibold text-white q2-mode-option-title">Fully Personalized</h2>
              <p className="q2-mode-option-meta mt-0.5 text-xs text-white/70">~10 minutes</p>

              <p className="mt-2.5 mb-4 text-sm leading-relaxed q2-mode-option-desc text-white/80" style={{ lineHeight: 1.55 }}>
                Share your ride preferences, show &amp; fireworks picks, dining choices, character meet &amp; greets, premium experiences, and any celebrations — so your itinerary feels uniquely yours.
              </p>

              <span className="inline-flex gap-2 justify-center items-center px-4 py-2.5 mt-auto w-full text-sm font-semibold text-white bg-blue-600 rounded-lg shadow-sm transition-all duration-200 group-hover:bg-blue-500 group-focus:ring-2 group-focus:ring-blue-500 group-focus:ring-offset-2 group-focus:ring-offset-slate-900">
                Build My Personalized Plan
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </button>

            <button
              type="button"
              onClick={onChooseFastTrack}
              className={[
                "flex flex-col p-5 text-left rounded-xl transition-all duration-200",
                "q2-mode-option group focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-900",
                "focus:ring-indigo-400",
                "sm:p-5",
              ].join(' ')}
              aria-label="Choose the fast track for a quick plan with essentials"
            >
              <div className="flex justify-center items-center mb-3 w-11 h-11 rounded-lg border text-gold-600 shrink-0 bg-gold-600 border-gold-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>

              <h2 className="text-lg font-semibold text-white q2-mode-option-title">Fast &amp; Simple</h2>
              <p className="q2-mode-option-meta mt-0.5 text-xs text-white/70">~2 minutes</p>

              <p className="mt-2.5 mb-4 text-sm leading-relaxed q2-mode-option-desc text-white/80" style={{ lineHeight: 1.55 }}>
                Just the essentials — dates, group, parks, tickets, and timing. Great if you want a strong itinerary with minimal effort.
              </p>

              <span
                className={[
                  "inline-flex gap-2 justify-center items-center px-4 py-2.5 mt-auto w-full text-sm font-semibold",
                  "rounded-lg shadow-sm transition-all duration-200",
                  "text-white bg-white/12 border border-white/25 group-hover:bg-white/20 group-hover:border-white/30",
                  "group-focus:ring-2 group-focus:ring-indigo-400 group-focus:ring-offset-2 group-focus:ring-offset-slate-900",
                ].join(' ')}
              >
                Start Fast Plan
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </button>
          </div>

          <div className="mt-4 text-center">
            <p className="q2-mode-footer flex flex-wrap items-center justify-center gap-1.5 text-sm leading-relaxed text-white/70">
              <svg className="w-4 h-4 shrink-0 text-white/60" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4M12 22a10 10 0 100-20 10 10 0 000 20z"
                />
              </svg>
              You can switch to the full questionnaire anytime.
              {hasAgentBranding && <span> Your answers are shared only with your agent.</span>}
            </p>
          </div>

          <div className="flex flex-col items-center pt-4 pb-3 mt-1">
            <span className="mb-1.5 text-xs text-white/50">Built By:</span>
            <img src={parkProLogo} alt="ParkPro" className="object-contain w-auto h-12 opacity-70 transition-opacity q2-mode-footer-logo hover:opacity-90" />
          </div>
        </main>
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireModeChoice;
